import { AxiosGlobalSettingsApi } from "./common/Api";
import { HtmlPurifyText } from "./utils/HTMLText";

export const setupInjections = async () => {
  const { stonly_id, hubspot_id } = await AxiosGlobalSettingsApi.getAll({});

  if (stonly_id) {
    const stonlyHtml = `
      var STONLY_WID = "${stonly_id}";
      !function(s,t,o,n,l,y,w,g){s.StonlyWidget||((w=s.StonlyWidget=function(){
          w._api?w._api.apply(w,arguments):w.queue.push(arguments)}).queue=[],(y=t.createElement(o)).async=!0,
          (g=new XMLHttpRequest).open("GET",n+"version?v="+Date.now(),!0),g.onreadystatechange=function(){
          4===g.readyState&&(y.src=n+"stonly-widget.js?v="+(200===g.status?g.responseText:Date.now()),
          (l=t.getElementsByTagName(o)[0]).parentNode.insertBefore(y,l))},g.send())
          }(window,document,"script","https://stonly.com/js/widget/v2/");
    `;
    let script = document.createElement("script");
    script.innerHTML = HtmlPurifyText(stonlyHtml);
    document.head.appendChild(script);
  }

  if (hubspot_id) {
    const script = document.createElement("script");

    script.id = "hs-script-loader";
    script.async = true;
    script.defer = true;
    script.src = `//js.hs-scripts.com/${hubspot_id}.js`;

    document.body.appendChild(script);
  }
};
